module.exports = __webpack_public_path__ + "static/media/bfile-renter.7af09506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-renter.svg
// module id = 1014
// module chunks = 0